import { Document } from 'schemas/DocumentSchema'
import { TimeZoneStrings } from 'enums/TimeZone'
import { Metadata } from './metadata'

export class DeletedDocumentMetadataAdaptor implements Metadata {
  constructor(private document: Document, private timeZone: TimeZoneStrings) {}

  getTimeZone = () => this.timeZone

  getDocument = () => undefined

  isVocDisplay = () => undefined

  isNeedTruncated = () => undefined

  getTruncatedLength = () => undefined

  getWidgetType = () => undefined

  getAuthor = () => undefined

  getAuthorId = () => undefined

  getAuthorKarma = () => undefined

  getAuthorLink = () => undefined

  getAuthorLocation = () => undefined

  getAuthorName = () => undefined

  getAuthorUrl = () => undefined

  getAuthorHandle = () => undefined

  getAvatarUrl = () => undefined

  getOriginalAuthorAvatarUrl = () => undefined

  getOriginalAuthorHandle = () => undefined

  getDateTime = () => this.document.properties.datetime

  getDisplayTextRange = () => undefined

  getDocumentId = () => undefined

  getDomain = () => undefined

  getHighlightingInfos = () => []

  isDocumentMode = () => undefined

  getOriginalAuthor = () => undefined

  getOriginalAuthorName = () => undefined

  getOriginalAuthorUrl = () => undefined

  getPostType = () => undefined

  getPostId = () => undefined

  getSentences = () => []

  getSentenceInfos = () => undefined

  getSoundbiteSentiment = () => undefined

  getUrl = () => undefined

  getFavicon = () => undefined

  getMentionedUrls = () => undefined

  getAuthorFollower = () => undefined

  getAuthorGender = () => undefined

  getAuthorGeoInfos = () => undefined

  isTweet = () => false

  getDataStreams = () => undefined

  getAnnotatedSentiment = () => undefined

  isDeleted = () => true

  isSimilar = () => ''

  getDocumentMetaTags = () => []

  getSentenceAllTags = () => undefined

  getSentenceUserTags = () => undefined

  getSentenceMetaTags = () => undefined

  getUserTags = () => undefined

  getMetaTags = () => undefined

  getTitle = () => undefined

  isAuthorVerified = () => undefined

  isOriginalAuthorVerified = () => undefined

  getSourceType = () => undefined

  getSourceName = () => undefined

  getHitSentence = () => undefined

  getProfessions = () => []

  getInterests = () => []

  getEngagement = () => ''

  getReplies = () => ''

  getComments = () => undefined

  getImpressions = () => undefined

  getShares = () => undefined

  getNegSentiment = () => undefined

  getPassion = () => undefined

  getPosSentiment = () => undefined

  getReblogs = () => undefined

  getSentiments = () => undefined

  getRetweets = () => ''

  getLikes = () => ''

  getViews = () => undefined

  getScore = () => undefined

  getProductName = () => undefined

  getDocHierarchy = () => undefined

  getPostRating = () => undefined

  getPhotoUserTags = () => []

  getAdsType = () => undefined

  getPersistId = () => undefined

  getOverallStarRating = () => undefined

  getOverallSurveyScore = () => undefined

  getNetPromoterScore = () => undefined

  getMeasurements = () => undefined

  getSentenceMeasurements = () => undefined

  getParentDistilledTexts = () => undefined

  getParentDisplayTextRange = () => undefined

  getParentMentionedUrls = () => undefined

  getFingerprint = () => undefined

  getSentenceNumber = () => undefined
}

export default DeletedDocumentMetadataAdaptor
